/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable class-methods-use-this */
import React, { Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';

import './Overview.scss';

import iconUsers from '../../../assets/images/icon_usuarios.svg';
import iconMessagesReceived from '../../../assets/images/icon_mensagem_recebida.svg';
import iconMessagesSent from '../../../assets/images/icon_mensagem_enviada.svg';

import BotHeader from '../../../components/Builder/BotHeader/BotHeader';
import { BotsCreators } from '../../../store/actions/bots';
import { UserActions } from '../../../store/actions/users';

import OverviewCard from '../../../components/Builder/Overview/OverviewCard';
import OverviewChannels from '../../../components/Builder/Overview/OverviewChannels';
import BotCollectData from './Components/BotCollectData';
import Footer from '../../../components/Footer2/index';

/**
 * Component for show the main content about bot
 *
 *
 * @param {Object} props data for this component
 * @returns
 */
const Overview = (props) => {
  const { i18n, bot, updateBotStatus, match, user } = props;
  const { botid: botId } = match.params;

  /**
   * Called for retrieve the bot data
   */
  useEffect(() => {
    const { retrieveBotRequest } = props;
    if (!props?.bot?._id) {
      retrieveBotRequest(botId);
    }
  }, []);

  /**
   * Render component main page content
   */
  const renderContent = () => {
    if (_.isEmpty(bot)) {
      return false;
    }

    return (
      <div>
        <BotHeader bot={bot} updateBotStatus={updateBotStatus} user={user} />
        <div className="row divider-container">
          <div className="divider-filter-line" />
          <div className="divider-filter-text">{i18n.t('últimos 30 dias')}</div>
          <div className="divider-filter-line" />
        </div>
        <div className="row linha-conteudo-overview">
          <div className="col-md-12 conteudo-iniciar">
            <OverviewCard
              icon={iconUsers}
              label={i18n.t('Sessões')}
              count={bot?.counts?.sessions || 0}
              countColor="color-orange"
            />
            <OverviewCard
              icon={iconMessagesReceived}
              label={i18n.t('Mensagens Recebidas')}
              count={bot?.counts?.userMessages || 0}
              countColor="color-red"
            />
            <OverviewCard
              icon={iconMessagesSent}
              label={i18n.t('Mensagens Enviadas')}
              count={bot?.counts?.botMessages || 0}
              countColor="color-green"
            />
            <BotCollectData />
          </div>
          <div
            className="col-md-12 d-flex justify-content-center"
            style={{ marginBottom: '3%' }}
          >
            <OverviewChannels bot={bot} />
          </div>
          <Footer />
        </div>
      </div>
    );
  };

  return <Fragment>{renderContent()}</Fragment>;
};

const mapStateToProps = (state) => {
  return {
    bot: state.bots.bot,
    user: state.users.signedUser,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators, ...UserActions }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Overview))
);
